import { Trans, useTranslation } from 'next-i18next';
import { FC } from 'react';

import { useIsPreOrder } from '../../../../hooks/useIsPreOrder';
import { useResaleAgreement } from '../../../../hooks/useResaleAgreement';
import { useAuth } from '../../../../providers';
import { usePreAuthDrawCtx } from '../../../../providers/PreAuthDrawProvider';
import { usePurchase } from '../../../../providers/PurchaseProvider';
import { getFirstAndLastWords } from '../../../../utils/strings';
import { PaymentType } from '../../types';

interface Props {
  payWithCrypto: boolean;
  productTags?: string[];
  productTitle: string;
}

export const ReviewDrawFooter: FC<Props> = ({
  payWithCrypto,
  productTags = [],
  productTitle,
}) => {
  const { t } = useTranslation('product');
  const purchasingController = usePurchase();
  const { draw, selectedPaymentType } = usePreAuthDrawCtx();
  const { user } = useAuth();
  const isPreOrder = useIsPreOrder(draw);

  const isCardPayment = selectedPaymentType === PaymentType.CARD;

  const [firstName, lastName] = getFirstAndLastWords(
    user?.fullName || undefined,
  );

  const resaleAgreementLink = useResaleAgreement({
    firstName,
    lastName,
    productTags,
    productTitle,
  });

  return (
    <div className="px-6 text-center text-xs text-neutral-4">
      {isCardPayment ? (
        <>
          {isPreOrder
            ? t('drawers.review.draw.legalDisclaimerOnPreOrder')
            : t('drawers.review.draw.legalDisclaimerOnEnter')}{' '}
        </>
      ) : null}
      {payWithCrypto
        ? t('drawers.review.draw.legalDisclaimerOnEnterCrypto')
        : null}
      {/* Exclusive check for false to make sure no product doesn't mean no RA */}
      {purchasingController.product?.noResaleAgreement === false && (
        <>
          {isCardPayment || payWithCrypto ? (
            <Trans
              i18nKey="drawers.review.draw.legalDisclaimerOnEnterResale"
              t={t}
            >
              And you agree that you have read and accept our&nbsp;
              <a
                className="hyperlink"
                href={resaleAgreementLink}
                rel="noreferrer"
                target="_blank"
              >
                Resale Agreement
              </a>
            </Trans>
          ) : (
            <>
              {isPreOrder ? (
                <Trans
                  i18nKey="drawers.review.draw.legalDisclaimerOnPreOrderResaleNonCard"
                  t={t}
                >
                  By pre-ordering you agree that you have read and accept
                  our&nbsp;
                  <a
                    className="hyperlink"
                    href={resaleAgreementLink}
                    rel="noreferrer"
                    target="_blank"
                  >
                    Resale Agreement
                  </a>
                  &nbsp; if you win.
                </Trans>
              ) : (
                <Trans
                  i18nKey="drawers.review.draw.legalDisclaimerOnEnterResaleNonCard"
                  t={t}
                >
                  By entering the draw you agree that you have read and accept
                  our&nbsp;
                  <a
                    className="hyperlink"
                    href={resaleAgreementLink}
                    rel="noreferrer"
                    target="_blank"
                  >
                    Resale Agreement
                  </a>
                  &nbsp; if you win.
                </Trans>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};
